import classNames from 'clsx'
import { arrayOf, bool, number, oneOf, shape, string } from 'prop-types'

import {
  AVAILABLE_PRESCRIPTION_TYPES,
  AVAILABLE_PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import { shouldShowThePriceWithExtraMargin } from 'shared/utils/productTemplateUtils'
import ProductVariant from 'views/components/organisms/ProductVariants/ProductVariant'
import { ProductVariantType } from 'views/utils/propTypes'

import './ProductVariantsBody.scss'

const ProductVariantsBody = ({
  variants,
  groupName,
  radioButton,
  productTemplate,
  prescriptionType,
  currentVariantId,
  lowestPrice,
  isMasterPage,
  isVariantAttributeFlag,
}) => {
  const className = classNames('a-list-reset o-ProductVariantsBody', {
    'o-ProductVariantsBody--single-variant': variants.length === 1,
  })

  const withExtraMargin = shouldShowThePriceWithExtraMargin(
    variants,
    prescriptionType
  )

  return (
    <ul className={className}>
      {variants.map((variant, index) => (
        <li
          className={classNames('m-ProductVariants__item', {
            'm-ProductVariants__list__firstItem':
              variants.length > 1 && index === 0,
          })}
          key={`variant-${variant.unitQuantityString}`}
        >
          <ProductVariant
            variant={variant}
            variantOffer={
              variant.offers?.find(offer =>
                variant.offerId
                  ? variant.offerId === offer.offerId
                  : offer.offerFlags?.includes('bestPrice')
              ) || undefined
            }
            groupName={groupName}
            radioButton={radioButton}
            productTemplate={productTemplate}
            prescriptionType={prescriptionType}
            isLast={index === variants.length - 1}
            lowestPrice={lowestPrice}
            isMasterPage={isMasterPage}
            checked={currentVariantId === variant.id}
            withExtraMargin={withExtraMargin}
            isVariantAttributeFlag={isVariantAttributeFlag}
          />
        </li>
      ))}
    </ul>
  )
}

ProductVariantsBody.propTypes = {
  variants: arrayOf(shape(ProductVariantType)).isRequired,
  currentVariantId: string,
  groupName: string.isRequired,
  radioButton: bool.isRequired,
  productTemplate: oneOf(AVAILABLE_PRODUCT_TEMPLATES).isRequired,
  prescriptionType: oneOf(AVAILABLE_PRESCRIPTION_TYPES.ALL).isRequired,
  lowestPrice: number,
  isMasterPage: bool,
  isVariantAttributeFlag: bool,
}

ProductVariantsBody.defaultProps = {
  currentVariantId: null,
  isMasterPage: false,
  isVariantAttributeFlag: false,
}

export default ProductVariantsBody
